import { EntitySectionLayout } from "@/shared/components/common/EntitySectionLayout";
import { ContentCreatorsHeader } from "./ContentCreatorsHeader";

export function ContentCreatorsLayout() {
  return (
    <EntitySectionLayout
      basePath="/content-creators"
      HeaderComponent={ContentCreatorsHeader}
      hideHeaderMatchers={["add-content-creators", "edit/", "view-profile"]}
    />
  );
}
